<template>
    <Layout>
        <Header>
            <header-bar>
                <div slot="logo" class="page-logo" @click="toIndex()">
                    <Tooltip
                        :content="userInfo.tenant_name + '--(智维平台)'"
                        placement="right"
                    >
                        <span class="min-logo"
                            ><img
                                :src="this.$store.state.user.webLogo"
                                key="min-logo"
                        /></span>
                    </Tooltip>
                </div>
                <div slot="project" class="project">
                    <div style="margin-left: 15px">
                        <div
                            class="showtitle"
                            style="color: #666; cursor: pointer"
                        >
                            <Icon type="md-apps" size="18" color="#999" />
                            {{ userInfo.tenant_business_name }}
                        </div>
                    </div>
                </div>
                <users
                    :user-name="userName"
                    :posts="userInfo.posts_name"
                    :email="userInfo.email"
                    :isadmin="userInfo.isadmin"
                    :realname="userInfo.realname"
                    :user-avatar="userAvatar"
                    style="margin-right: 9px"
                >
                </users>
                <fullscreen v-model="isFullscreen" />
                <notifications :count="unreadCount" :data="datalist">
                </notifications>
            </header-bar>
        </Header>
        <Layout>
            <Sider
                hide-trigger
                collapsible
                :width="244"
                :collapsed-width="74"
                v-model="collapsed"
                :style="{ overflow: 'hidden' }"
            >
                <side-menu
                    accordion
                    ref="sideMenu"
                    :active-name="$route.name"
                    :collapsed="collapsed"
                    @on-select="turnToPage"
                    :menu-list="menuList"
                ></side-menu>
            </Sider>
            <Content :class="!collapsed ? 'max-content' : 'min-content'">
                <Layout class="main-layout-con">
                    <Content class="content-wrapper">
                        <keep-alive>
                            <router-view />
                        </keep-alive>
                    </Content>
                </Layout>
            </Content>
        </Layout>
    </Layout>
</template>

<script>
// import minLogo from '@/assets/img/min-logo.png'
// import maxLogo from '@/assets/img/max-logo.png'

import HeaderBar from "@/components/header-bar";
import fullscreen from "@/components/fullscreen";
import notifications from "@/components/notifications";
import users from "@/components/users";
import SideMenu from "@/components/side-menu";
import DropdownProject from "@/components/dropdown/";

import { mapMutations, mapActions, mapGetters } from "vuex";

export default {
    name: "Main",
    data() {
        return {
            // maxLogo,
            // minLogo,
            isFullscreen: false,
        };
    },
    components: {
        HeaderBar,
        users,
        SideMenu,
        fullscreen,
        notifications,
        DropdownProject,
    },
    computed: {
        userInfo() {
            return this.$store.state.user.userInfo;
        },
        collapsed() {
            return this.$store.state.app.collapsed;
        },
        projectItem() {
            return this.$store.state.project.projectitem;
        },
        userName() {
            return this.$store.state.user.userName;
        },
        userAvatar() {
            return this.$store.state.user.avatarImgPath;
        },
        menuList() {
            return this.$store.getters.menuList;
        },
        unreadCount() {
            return this.$store.state.user.unreadCount;
        },
        datalist() {
            return this.$store.state.user.messageUnreadList;
        },
        personListes() {
            return this.$store.state.common.personList;
        },
    },
    methods: {
        ...mapMutations([
            "setBreadCrumb",
            "setCollapsed",
            "setHomeRoute",
            "setTagNavList",
            "addTag",
            "closeTag",
        ]),
        ...mapActions([
            "getUnreadMessageCount",
            // "getMessageList",
            "handleProject",
            "handleTaskData",
            "handleTaskDetail",
            "handleUserlist",
        ]),
        toIndex() {
            this.$router.push({
                name: this.$config.homeName,
            });
        },
        turnToPage(route) {
            let { name, params, query } = {};
            if (typeof route === "string") {
                name = route;
            } else {
                name = route.name;
                params = route.params;
                query = route.query;
            }

            if (name.indexOf("isTurnByHref_") > -1) {
                window.open(name.split("_")[1]);
                return;
            }

            this.$router.replace({
                name,
                params,
                query,
            });
        },
        handleCollapsedChange(state) {
            this.setCollapsed(state);
        },
    },
    watch: {
        $route(newRoute) {
            // this.handleTaskData()

            const { name, query, params, meta } = newRoute;
            this.addTag({
                route: { name, query, params, meta },
                type: "push",
            });
            // this.$refs.sideMenu.updateOpenName(newRoute.name)
            // this.setTagNavList(getNewTagList(this.tagNavList, newRoute))
        },
    },
    mounted() {
        const { name, params, query, meta } = this.$route;
        this.addTag({
            route: { name, params, query, meta },
        });
        this.handleProject({});
        this.getUnreadMessageCount();
        // this.getMessageList();
        this.handleUserlist();
        this.handleTaskData();

        this.$Notice.config({
            top: 80,
            duration: 4,
        });

        // 如果当前打开页面不在标签栏中，跳到homeName页
        // if (!this.tagNavList.find(item => item.name === this.$route.name)) {
        //   this.$router.push({
        //     name: this.$config.homeName
        //   })
        // }
    },
};
</script>
